






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog } from 'vant';
import { enumToObject } from '@/utils/util';

enum TypeEnum {
  已评分 = 0,
  待评分 = 1,
}

@Component
export default class ShiftEvaluation extends Vue {
  @Prop() classInfo: any;
  @Prop() type: TypeEnum;

  show: boolean = false;

  showLevelPicker: boolean = false;

  levelValue: string = ''; // 显示的等级string

  columns = [
    {
      values: [
        models.EvaluationLevel[models.EvaluationLevel.优秀],
        models.EvaluationLevel[models.EvaluationLevel.良好],
        models.EvaluationLevel[models.EvaluationLevel.一般],
        models.EvaluationLevel[models.EvaluationLevel.差],
        models.EvaluationLevel[models.EvaluationLevel.较差],
      ],
      defaultIndex: 0,
    },
  ];

  comprehensiveForm: models.ComperhensiveEvaluationDto = {
    classType: null,
    trainingAgencyId: null,
    trainingAgencyName: '',
    className: '',
    deptId: null,
    trainingAgencyStorage: '',
    trainingAgencyDicValue: null,
    organizerStorage: '',
    organizerDicValue: null,
    content: '',
    score: 0,
    level: null,
    sponsor: '',
    id: null,
    classId: null,
  };

  @Watch('show', { deep: true, immediate: true })
  showChange() {
    if (!this.show) return;
    if (this.type == TypeEnum.待评分) {
      Object.keys(this.comprehensiveForm).forEach(k => {
        if (k in this.classInfo) this.comprehensiveForm[k] = JSON.parse(JSON.stringify(this.classInfo[k]));
      });
      if (!this.comprehensiveForm.sponsor) this.comprehensiveForm.sponsor = this.classInfo.deptName;
      this.comprehensiveForm.content = '';
    } else {
      Object.keys(this.comprehensiveForm).forEach(k => {
        if (k in this.classInfo) this.comprehensiveForm[k] = JSON.parse(JSON.stringify(this.classInfo[k]));
      });
      this.comprehensiveForm.classId = this.classInfo.publicTrainingClassId;
      this.levelValue = models.EvaluationLevel[this.classInfo.level];
      if (!this.comprehensiveForm.sponsor) this.comprehensiveForm.sponsor = this.classInfo.deptName;
    }
  }

  onLevelConfirm(value) {
    this.levelValue = value;
    this.comprehensiveForm.level = enumToObject(models.EvaluationLevel).find(e => e.label == value).value;
    this.showLevelPicker = false;
  }

  onBlur(val) {
    const num = val.target.value;
    if (num < 0 || num > 100) {
      Dialog.alert({
        message: '请输入0-100区间的数',
      });
    }
  }

  async onSubmit() {
    if (this.comprehensiveForm.score < 0 || this.comprehensiveForm.score > 100)
      Dialog.alert({
        message: '请输入0-100区间的数',
      });
    try {
      const { data, success, message } = await api.ComperhensiveEvaluation.save_POST(this.comprehensiveForm);
      if (success) {
        //评价成功，清空form
        Dialog.alert({
          message: '评价成功',
        });

        this.comprehensiveForm = {
          classType: null,
          trainingAgencyId: null,
          trainingAgencyName: '',
          className: '',
          deptId: null,
          trainingAgencyStorage: '',
          trainingAgencyDicValue: null,
          organizerStorage: '',
          organizerDicValue: null,
          content: '',
          score: null,
          sponsor: '',
          id: null,
          classId: null,
          level: null,
        };
        this.show = false;
        this.$emit('classCancel');
      } else {
        Dialog.alert({
          message: '评价失败',
        });
      }
    } catch (e) {
      Dialog.alert({
        message: e,
      });
    }
  }

  onClickLeft() {
    this.$router.go(-1);
  }
}
